module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-techo-e4f49a02057acf77043d5cd4d345084a.jpg";